import * as React from 'react';

import { darken, transparentize } from 'polished';
import styled from 'styled-components';

import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../packages/constants';

export interface NumberInputProps {
    autoComplete?: string;
    autoFocus?: boolean;
    dataId: string;
    defaultValue?: string | string[];
    disabled?: boolean;
    id: string;
    invalid?: boolean;
    max?: number | string;
    min?: number | string;
    name: string;
    onChange?: (e: any) => void;
    onBlur?: (e: any) => void;
    placeholder?: string;
    required?: boolean;
    step?: number | string;
    value?: string | string[] | number;
    className?: string;
    ariaLabel?: string;
}

interface StyledInputProps {
    disabled?: boolean;
    invalid?: boolean;
}

const StyledInput = styled.input<StyledInputProps>`
    background-color: ${(props: StyledInputProps): string =>
        props.disabled ? darken('0.1', COLOR.PRIMARY.WHITE) : COLOR.PRIMARY.WHITE};
    color: ${(props: StyledInputProps): string =>
        props.disabled ? transparentize('0.5', COLOR.PRIMARY.BLACK) : COLOR.PRIMARY.BLACK};
    font-size: ${FONT_SIZE.SMALL};
    line-height: ${FONT_SIZE.MEDIUM};
    padding: ${SPACING.SMALL};
    border-width: 1px;
    border-style: solid;
    border-color: ${(props: StyledInputProps): string => (props.invalid ? COLOR.PRIMARY.RED : COLOR.MAIN.FORM_FIELD)};
    border-radius: ${RADIUS.DEFAULT};

    &::placeholder {
        opacity: 0.65;
    }
`;

export const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
    (
        {
            autoComplete,
            autoFocus,
            dataId,
            defaultValue,
            disabled,
            id,
            invalid,
            max,
            min,
            name,
            placeholder,
            required,
            step,
            value,
            onChange,
            onBlur,
            ariaLabel,
        },
        ref,
    ) => {
        return (
            <StyledInput
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                data-test-id={dataId}
                {...(typeof defaultValue !== 'undefined' && { defaultValue })}
                disabled={disabled}
                id={id}
                invalid={invalid}
                max={max}
                min={min}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                ref={ref}
                required={required}
                step={step}
                type="number"
                {...(typeof value !== 'undefined' && { value })}
                {...(ariaLabel && { 'aria-label': ariaLabel })}
            />
        );
    },
);
NumberInput.displayName = 'NumberInput';
